export default store => store.samples;
